import { useEffect, useState } from 'react';
import { useDebounceValue } from 'usehooks-ts';
import { filter } from '../../../pages/fleet-calculator/copy';
import useSettingsStore from '../store/settings-store';
import { percentToDecimal } from '../utils/calc';

const MarginalTax = () => {
  const { updateSettingsStore, percentTaxRate } = useSettingsStore();

  const [tax, setTax] = useState(percentTaxRate * 100);
  const [taxDebouncedValue, setTaxDebouncedValue] = useDebounceValue(
    percentTaxRate * 100,
    200,
  );

  useEffect(() => {
    updateSettingsStore({
      percentTaxRate: percentToDecimal(taxDebouncedValue),
    });
  }, [taxDebouncedValue]);

  useEffect(() => {
    setTaxDebouncedValue(tax);
  }, [tax]);

  return (
    <>
      <div className="flex flex-col gap-2">
        <div className="flex gap-2 justify-between">
          <label htmlFor="marnigal-tax">{filter.marginalTax}</label>
          <p>{tax} %</p>
        </div>
        <input
          onChange={(e) => setTax(Number(e.target.value))}
          type="range"
          id="marnigal-tax"
          className="ring-dark-blue ring-offset-1 focus-visible:ring-2 transition-shadow"
          defaultValue={tax}
          min={30}
          max={55}
        />
      </div>
    </>
  );
};

export default MarginalTax;
